module.exports = __webpack_public_path__ + "static/media/backpack_white.3b7db9f5.png";